import { SET_PROTOCOLS } from "../constants"
// eslint-disable-next-line
export const setProtocols = (protocols) => ({
  protocols,
  ssoEnabled: protocols.length !== 0,
  type: SET_PROTOCOLS,
})
